import { RouterProvider, RouterProviderProps } from '@main/shared-exports';

import '@insurely/ui/css/bootstrap.css';

function Root({ router }: { router: RouterProviderProps['router'] }) {
  return <RouterProvider router={router} />;
}

export default Root;
